import React from 'react';
import UnsubscribeContainer from '../../../Containers/UserContainer/Unsubscribe';

const UnsubscribeScreen = () => {
  return <UnsubscribeContainer />;
};

export default UnsubscribeScreen;
